import React from 'react';
import { Icon, useIsMobile } from '@amzn/storm-ui';
import { sparkleSolid } from '@amzn/storm-ui-icons';
import { LaunchFlagProps } from 'src/app/slice';
import { BetaAIFlag, BetaAILabelWrapper, Flag } from './styles';
import {
  formatFlagLabel,
  formatFlagType,
} from 'src/commons/components/LaunchFlag/LaunchFlag.utils';

const BetaAILabel = () => {
  return (
    <BetaAILabelWrapper>
      Beta <Icon type={sparkleSolid} />
      AI
    </BetaAILabelWrapper>
  );
};

export const LaunchFlag: React.VFC<LaunchFlagProps> = ({ flag }) => {
  const isMobile = useIsMobile();

  if (!flag) {
    return null;
  }

  const flagType = formatFlagType(flag.type);
  const flagLabel = formatFlagLabel(flag.label);

  const flagProps = {
    description: flag.description ?? flagLabel,
    $isInverted: !!flag.isInverted,
    $isMobile: isMobile,
    'data-ccx-e2e-id': `tag-${flagType}`,
  };

  switch (flagType) {
    case 'beta_ai_with_icon':
      return <BetaAIFlag label={<BetaAILabel />} {...flagProps} />;
    default:
      return <Flag variant={flagType} label={flagLabel} {...flagProps} />;
  }
};
